import api from '../auth';

// Service for catalogs delta sync
const CatalogsService = () => {
    const getChanges = async ({ since = null, embed = 'changed' } = {}) => {
        const params = new URLSearchParams();
        if (since) params.set('since', since);
        if (embed) params.set('embed', embed);
        const url = `/api/catalogs/changes${params.toString() ? `?${params.toString()}` : ''}`;
        const res = await api.get(url);
        return res.data;
    };

    return {
        getChanges
    };
};

export default CatalogsService;
